import { Component } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';

export interface item {
    color: string;
    background: string;
    text: string;
    router: string;
    icon: string;
}

@Component({
    selector: 'gestorfinanceiro',
    templateUrl: './gestorfinanceiro.component.html',
    styleUrls: ['./gestorfinanceiro.component.scss'],
    animations: fuseAnimations
})
export class GestorFinanceiroComponent {

    Menus: item[] = [
        { text: 'Integração Bancária', color: '#232323aa', background: 'transparent', router: '/integracaobancaria', icon: 'chat' },
        { text: 'Relatório de Cobrança', color: '#232323aa', background: 'transparent', router: '/relatorioCobranca', icon: 'chat' },
        { text: 'Relatório de Cobrança com erro', color: '#232323aa', background: 'transparent', router: '/critica-registro-boleto', icon: 'chat' },
    ];

    constructor() { }
}
